import React from "react";
import PropTypes from "prop-types"

import { TextField } from "@mui/material";

const Code = ({title, onChange, disabled }) => {

  const label = "Code *";

  return (
      <TextField
        fullWidth
        color="warning"
        name="code"
        size="small"
        value={title}
        onChange={onChange}
        label={label}
        disabled={disabled}
        />
  );
};

Code.propTypes = {
  title: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};

export default Code;
